/*
 * Wmb, Worldline Merchant Billing.
 * Copyright (C) 2017-2019 Worldline
 * All Rights Reserved
 * This product is protected by copyright. Any copying or distribution
 * is forbidden without the agreement of Worldline.
 */
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { KeycloakService } from 'security/keycloak.service';
import { Router } from '@angular/router';


import { NGXLogger } from 'ngx-logger';
import { ConfigurationService } from 'app/core/services/configuration.service';

@Injectable()
export class AuthentificationErrorResponseInterceptor implements HttpInterceptor {

    constructor(private keycloakService: KeycloakService,
        private router: Router,
        private configService: ConfigurationService,
        private log: NGXLogger
    ) {

    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).pipe(tap((event: HttpEvent<any>) => { }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
                if (err.status === 401) {

                    this.keycloakService.notifyErrorNotAuthorized();

                    if (this.configService.config.security.error401RedirectToURI === undefined) {
                        this.log.debug('Error 401 Not Authenticated ! Do nothing !');
                    } else if (this.configService.config.security.error401RedirectToURI === 'LOGIN') {
                        this.keycloakService.login().subscribe(loggedIn => {
                            if (loggedIn) {
                                this.log.debug('logged IN ! Success !');
                            } else {
                                this.log.debug('Not logged in - Login failed !');
                            }
                        });
                    } else {
                        this.log.debug('Error 401 Not Authenticated ! redirect to ', this.configService.config.security.error401RedirectToURI);
                        this.router.navigate([this.configService.config.security.error401RedirectToURI]);
                    }
                }
            }
        }));
    }
}
